module.exports = __webpack_public_path__ + "Roboto-msdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/Roboto-msdf.png
// module id = 7
// module chunks = 0